import { Undo2 } from "lucide-react";
import NotificationsContent from "./NotificationsContent";

export const NotificationsPopup = ({ open, onClose, onBack }) => {
  if (!open) return null;
  return (
    <div
      className="fixed bottom-36 right-4 sm:bottom-24 sm:right-6 z-[200] w-[90vw] max-w-[380px] h-[75vh] max-h-[560px]"
      data-testid="notifications-popup"
    >
      <button
        onClick={onBack}
        className="absolute -bottom-3 -right-3 w-8 h-8 rounded-full bg-[#F97316] hover:bg-[#EA580C] text-white shadow-lg ring-2 ring-white flex items-center justify-center z-10"
        data-testid="notifications-back-to-menu"
        aria-label="Volver al menú"
      >
        <Undo2 size={14} />
      </button>
      <div className="w-full h-full bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl border border-[#E2E8F0] overflow-y-auto p-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
        <NotificationsContent onClose={onClose} />
      </div>
    </div>
  );
};

export default NotificationsPopup;
